import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '~/services/queryClient'
import { getTasksTasks } from '~/services/superAdminService'

export interface TaskItem {
  id: number
  name: string
  status: string
  created_at: string
  updated_at: string
}

interface UseTasksListProps {
  conversationId: number | null
}

const useTasksList = ({ conversationId }: UseTasksListProps) => {
  const enabled = !!conversationId
  const { data: tasksList, isPending } = useQuery({
    queryKey: [conversationId, ...QueryKeys.AdminTasksList],
    queryFn: ({ queryKey }) => getTasksTasks(queryKey[0] as number),
    enabled,
    staleTime: 0,
    meta: {
      persist: false
    },
    select: data => (data?.tasks as TaskItem[]) || []
  })

  const tasks = tasksList ?? []
  const isLoading = enabled && isPending

  return { tasks, isLoading }
}

export default useTasksList
